import { SpeakerListItem } from '../../../services/api.service';
import { pad } from '../../files/files.page';
import { Speaker } from '../speakers.page';

export function formatSpeakerDate(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return `${pad(d.getDate())}.${pad(d.getMonth() + 1)}.${d.getFullYear()}`;
}

export function mapSpeakerFromApi(item: SpeakerListItem): Speaker {
  return {
    id: String(item.id),
    name: item.name,
    position: item.position || '—',
    date: formatSpeakerDate(item.created_at),
    duration: '00:00:00',
    hasVoice: item.has_voice,
    voice: null,
    file: null,
  };
}

export function formatDuration(seconds: number): string {
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = Math.floor(seconds % 60);
  return `${pad(h)}:${pad(m)}:${pad(s)}`;
}
